"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.default = withFirestore;

var _react = _interopRequireDefault(require("react")),
    _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics")),
    _utils = require("./utils"),
    _ReactReduxFirebaseContext = _interopRequireDefault(require("./ReactReduxFirebaseContext")),
    _ReduxFirestoreContext = _interopRequireDefault(require("./ReduxFirestoreContext"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  return _extends = Object.assign || function (target) {
    for (var source, i = 1; i < arguments.length; i++) {
      for (var key in source = arguments[i], source) {
        Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
      }
    }

    return target;
  }, _extends.apply(this, arguments);
}

function withFirestore(WrappedComponent) {
  function WithFirestore(props) {
    return _react.default.createElement(_ReactReduxFirebaseContext.default.Consumer, null, function (firebase) {
      return _react.default.createElement(_ReduxFirestoreContext.default.Consumer, null, function (firestore) {
        return _react.default.createElement(WrappedComponent, _extends({
          firestore: firestore,
          firebase: firebase,
          dispatch: firebase.dispatch
        }, props));
      });
    });
  }

  return WithFirestore.displayName = (0, _utils.wrapDisplayName)(WrappedComponent, "withFirestore"), WithFirestore.wrappedComponent = WrappedComponent, (0, _hoistNonReactStatics.default)(WithFirestore, WrappedComponent);
}

module.exports = exports.default;